import { _ as __rest, a as __assign } from './tslib.es6-18cb2814.js';
import React__default from 'react';

function LeftArrowIcon(_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 12" }, props),
        React__default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.createElement("g", { transform: "translate(-1031 -266) translate(1031 256)" },
                React__default.createElement("path", { fill: fillColor, fillRule: "nonzero", d: "M15.667 5.167V6.5c0 .4-.267.667-.667.667H4.867l2.4 2.4c.133.133.133.333 0 .466l-1.4 1.4c-.134.134-.334.134-.467 0l-5.2-5.2c-.267-.266-.267-.666 0-.933L5.4.1c.133-.133.333-.133.467 0l1.4 1.4c.133.133.133.333 0 .467l-2.4 2.4H15c.4.133.667.4.667.8z", transform: "translate(0 10)" })))));
}

export { LeftArrowIcon as L };
